module.exports = __webpack_public_path__ + "static/media/logosup.33657110.png";